import { Table } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FecAccountMappingSortKey } from '../../../../../../enums/fecAccountMappingSortKey'
import type { FecAccountMappingSortDirection } from '../../../../../../utils/sortFecAccountMappings'

interface ChartOfAccountsTableHeaderProps {
  accountNoSortDirection: FecAccountMappingSortDirection
  onSort: (key: FecAccountMappingSortKey) => void
  statusSortDirection: FecAccountMappingSortDirection
}

export const ChartOfAccountsTableHeader = ({
  accountNoSortDirection,
  onSort,
  statusSortDirection,
}: ChartOfAccountsTableHeaderProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell
          onSort={() => onSort(FecAccountMappingSortKey.AccountNo)}
          sortable
          sortDirection={accountNoSortDirection}
          width={136}
        >
          {t(
            'settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.columns.account_no',
          )}
        </Table.HeaderCell>
        <Table.HeaderCell>
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.columns.label')}
        </Table.HeaderCell>
        <Table.HeaderCell width={160}>
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.columns.type')}
        </Table.HeaderCell>
        <Table.HeaderCell
          onSort={() => onSort(FecAccountMappingSortKey.Status)}
          sortable
          sortDirection={statusSortDirection}
          width={180}
        >
          {t('settings.organization.accounting.fec_file_import.modal.mapping_step.chart_of_accounts.columns.status')}
        </Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  )
}
